import React from 'react';
import { DocumentTeaser, measures } from '@mendeley-internal/react-ui';
import styled from 'styled-components';
import PublicationStats from './PublicationStats/PublicationStats';
import PublicationActions from './PublicationActions/PublicationActions';

const track = { context: 'Document', value: { origin: 'Header' } };

const StyledDocumentTeaser = styled(DocumentTeaser)`
  h2[class^="TitlePrimary"] {
    font-family: NexusSans;
    font-size: ${measures(9)};
    line-height: 1.25;
  }

  div[class^="DocumentTeaser__StyledListAuthor"], div[class^="Metadata"] {
    * {
      font-family: NexusSans;
      font-size: calc(${measures(4)} + 0.125rem);
      line-height: 1.25;
    }
  }
`;

const renameAuthors = authors =>
  authors.map(({ firstName, lastName }) => ({
    first_name: firstName,
    last_name: lastName,
  }));

// The weblet-catalog translates snake cased JSON into camel case
// However the DocumentTeaser assumes snake case in alignment with the API
const formatDoc = doc => ({
  ...doc,
  accessed: doc.accessed && doc.accessed.join('-'),
  link: null, // Prevent the title from being a clickable link
  authors: Array.isArray(doc.authors)
    ? renameAuthors(doc.authors)
    : doc.authors,
});

export default function Header({ doc }) {
  return (
    <div className="dss-filled-container">
      <div className="row">
        <div className="column d-7-10 m-7-10 s-1-1 xs-1-1">
          <StyledDocumentTeaser
            document={formatDoc(doc)}
            className={doc.isEntitledToPdf ? 'has-pdf' : ''}
          />
        </div>
        <div className="column d-3-10 m-3-10 s-1-1 xs-1-1">
          <PublicationStats
            readerCount={doc.readerCount}
            documentId={doc.id}
            scopusDocumentId={doc.identifiers && doc.identifiers.scopus}
          />
        </div>
      </div>
      <div className="row actions">
        <div className="column">
          <PublicationActions
            doc={doc}
            track={track}
          />
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Header.js